import { render, staticRenderFns } from "./SuiviItem.vue?vue&type=template&id=7b3a917d&"
import script from "./SuiviItem.vue?vue&type=script&lang=js&"
export * from "./SuiviItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports